import { css } from 'astroturf';
import React, { useState, useEffect } from 'react';
import ReactTooltip from 'react-tooltip';

import ScrollSync from './ScrollSync';
import ScrollSyncPane from './ScrollSyncPane';

const styles = css`
  .liveDemo {
    color-scheme: dark;
    position: relative;
    overflow: hidden;
    text-align: center;
    padding: 4rem 2rem;
    margin-bottom: 6rem;
    background: #0f181f url(../../../assets/images/15.jpg) no-repeat top center/contain;
    color: rgb(255, 255, 255);
    scroll-margin-top: 100px;
    color-scheme: dark;
    box-shadow:
      rgba(0, 0, 0, 0.15) 0px 1px 0px inset,
      rgba(0, 0, 0, 0.15) 0px 0px 8px inset,
      rgba(0, 0, 0, 0.175) 0px 20px 30px inset;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: -100px;
      width: 100%;
      height: 100%;
      border-radius: 4rem;
      padding: 2rem 0;
      opacity: 0.5;

      mask-image: radial-gradient(ellipse at center, #000 40%, transparent 95%);
      background-image: radial-gradient(#208dc8 1px, transparent 0);
      background-size: 40px 40px;
      background-position: -19px -19px;
    }

    @media (forced-colors: active) {
      border-top: 1px solid;
      border-bottom: 1px solid;
    }

    @media (max-width: 78rem) {
      display: none;
    }

    & .centered a {
      margin: 2rem auto 0 !important;
      max-width: 38rem;
    }

    & .skipButton {
    text-align: center;
    margin: 17px 0 0 10px;
    line-height: 30px;
    padding: 0 10px;
    border: 2px dashed #107db5;
    border-radius: 4px;
    background: #fff;
    z-index: 11;
    position: absolute;
    color: black;
    box-shadow: none;
    top: -70px;
    left: 50%;
    transform: translateX(-50%);
    width: 1px;
    height: 1px;
    overflow: hidden;

    clip: rect(0, 0, 0, 0);

    &:focus {
      top: 8px;
      clip: initial;
      width: initial;
      height: initial;
      outline-color: transparent;
    }

    &::after {
      display: none;
    }
  }

    & h2 {
      font-weight: 900;
      font-size: clamp(18px, 16px + 4vw, 44px);
      line-height: 1.25;
      margin: auto;
      margin-bottom: 0.5rem;
      margin-top: 0;
      letter-spacing: -0.015em;
      max-width: 60rem;
      text-shadow: 0px -1px 1px rgba(255, 255, 255, 0.55);
      filter: drop-shadow(20px 10px 20px rgba(5, 9, 12, 0.55));

      & svg {
        vertical-align: middle;
      }
    }

    & p {
      font-size: calc(16px + 0.25vw);
      font-weight: 400;
      position: relative;
      max-width: 52rem;
      margin: 0 auto 1.5rem;
      line-height: 1.6;
      @media (min-width: 770px) {
        font-size: 1.17rem;
      }
    }
  }
  .uiWrapper {
    margin: 0 auto;
    position: relative;
    width: 1200px;
    height: 604px;
    border-radius: 10px;
    ppadding: 10px;
  }

  .urlBarWrap {
    margin-bottom: 1.5rem;
    padding: 0.5rem;
    background: #fff4;
    border-radius: 16px;
    box-shadow:
      0px -1px 1px 0 rgba(255, 255, 255, 0.55),
      20px 10px 20px 0 rgba(5, 9, 12, 0.55);
  }
  .urlBar {
    background: #fff;
    padding: 0 1rem;
    border-radius: 10px;
    width: 100%;
    line-height: 40px;
    color: #767676;
    font-size: 16px;
    text-align: left;
    box-shadow:
      0px -1px 1px 0 rgba(255, 255, 255, 0.55),
      20px 10px 20px 0 rgba(5, 9, 12, 0.55);
    @media (forced-colors: active) {
      border: 1px solid;
    }
  }

  .mainWrapper {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 1870px;
    will-change: transform;
    transform-origin: 0 0;
    transform: scale(0.641);
    font-size: 1rem;
    gap: 2rem;
  }

  .smallPaneWrap {
    padding: 10px;
    background: #fff4;
    border-radius: 16px;
    box-shadow:
      0px -1px 1px 0 rgba(255, 255, 255, 0.55),
      20px 10px 20px 0 rgba(5, 9, 12, 0.55);
    backdrop-filter: blur(10px);
  }
  .smallPane {
    height: 568px;
    width: 320px;
    overflow: auto;
    overscroll-behavior: contain;
    box-shadow:
      0px -1px 1px 0 rgba(255, 255, 255, 0.55),
      20px 10px 20px 0 rgba(34, 33, 81, 0.55);
    border-radius: 10px;
    color-scheme: dark;
    @media (forced-colors: active) {
      border: 1px solid;
    }
  }

  .mediumPaneWrap {
    padding: 10px;
    background: #fff4;
    border-radius: 16px;
    box-shadow:
      0px -1px 1px 0 rgba(255, 255, 255, 0.55),
      20px 10px 20px 0 rgba(5, 9, 12, 0.55);
    backdrop-filter: blur(10px);
  }
  .mediumPane {
    height: 700px;
    width: 500px;
    overflow: auto;
    overscroll-behavior: contain;
    box-shadow:
      0px -1px 1px 0 rgba(255, 255, 255, 0.55),
      20px 10px 20px 0 rgba(34, 33, 81, 0.55);
    border-radius: 10px;
    color-scheme: dark;
    @media (forced-colors: active) {
      border: 1px solid;
    }
  }

  .largePaneWrap {
    padding: 10px;
    background: #fff4;
    border-radius: 16px;
    box-shadow:
      0px -1px 1px 0 rgba(255, 255, 255, 0.55),
      20px 10px 20px 0 rgba(5, 9, 12, 0.55);
    backdrop-filter: blur(10px);
  }
  .largePane {
    height: 800px;
    width: 920px;
    overflow: auto;
    overscroll-behavior: contain;
    box-shadow:
      0px -1px 1px 0 rgba(255, 255, 255, 0.55),
      20px 10px 20px 0 rgba(34, 33, 81, 0.55);
    border-radius: 10px;
    color-scheme: dark;
    @media (forced-colors: active) {
      border: 1px solid;
    }
  }

  .page {
    text-align: center;
    position: relative;
    background-color: #353746;
    color: #fff;
    padding-bottom: 5rem;
    color-scheme: dark;
  }

  .largePane .page {
  }

  .mediumPane .page {
  }

  .header {
    text-align: left;
    position: sticky;
    width: 100%;
    top: 0;
    padding: 0 1rem;
    line-height: 50px;
    height: 50px;
    font-weight: bold;
    z-index: 2;
  }

  .largePane .header {
  }

  .mediumPane .header {
  }

  .menuWrap {
    outline: none;
    position: absolute;
    right: 1rem;
    width: 32px;
    height: 32px;
    top: 8px;
    border-radius: 40px;
    background: transparent;
    border: 0;
    transition: 0.25s ease-in-out all;

    &.hover {
      background: #0a1530aa;
      -webkit-backdrop-filter: blur(10px);
      backdrop-filter: blur(10px);
    }
  }
  .menu {
    position: absolute;
    top: 16px;
    left: 6px;
    width: 20px;
    height: 2px;
    background: #fff;

    &::before {
      content: ' ';
      position: absolute;
      right: 0;
      top: -8px;
      width: 20px;
      height: 2px;
      background: #fff;
    }

    &::after {
      content: ' ';
      position: absolute;
      right: 0;
      bottom: -8px;
      width: 20px;
      height: 2px;
      background: #fff;
    }
  }

  .nav {
    position: absolute;
    z-index: 3;
    top: 48px;
    right: 8px;
    background: #0a1530aa;
    -webkit-backdrop-filter: blur(10px) saturate(150%);
    backdrop-filter: blur(10px) saturate(150%);
    border-radius: 20px;
    width: 90%;
    height: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    max-width: 480px;
    transition: 0.5s ease-in-out;
    display: grid;
    place-items: center;
    color: #fff0;

    &.open {
      color: #ffff;
      height: 450px;
      box-shadow:
        0 0px 3px rgba(0, 20, 50, 0.2),
        0 10px 15px -10px rgba(0, 40, 100, 0.15);

      &::before {
        content: ' ';
        position: absolute;
        top: -16px;
        right: 16px;
        border: 8px solid transparent;
        border-color: transparent transparent #0a1530aa transparent;
      }
    }
  }

  .intro {
    position: relative;
    max-width: 600px;
    text-align: center;
    margin: 0 auto;
    padding: 10% 1rem 5rem;

    font-size: 1.4rem;

    & b {
      margin-top: 1rem;
      display: block;
      font-size: 2.3rem;
      line-height: 1.2;
      color: #d8ecf8;
      background: linear-gradient(0deg, #d8ecf8 0, #98c0ef 100%);
      background-position: 50% 50%;
      background-clip: text;
      background-size: 100%;
      text-shadow: 0 2px 16px rgba(174, 207, 242, 0.24);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    & svg {
      width: 60%;
    }
  }

  .title {
    display: block;
    font-size: 2rem;
    padding: 0 2rem;
    line-height: 1.2;
    color: #d8ecf8;
    background: linear-gradient(0deg, #d8ecf8 0, #98c0ef 100%);
    background-position: 50% 50%;
    background-clip: text;
    background-size: 100%;
    text-shadow: 0 2px 16px rgba(174, 207, 242, 0.24);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-wrap: balance;

    &:has(+ .basicpadding) {
      margin-top: 4rem;
      margin-bottom: 2rem;
    }
  }

  .dots {
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    gap: 2rem 5rem;
    justify-content: space-around;
    flex-wrap: wrap;
    padding: 0 2rem;

    & div {
      text-align: center;
      max-width: 10rem;
      transition: 0.25s ease-in-out;
      transform: scale(1.05);
      text-wrap: balance;
      text-shadow: 0px 20px 20px rgba(0, 0, 10, 0.15);

      & span {
        color: #fff;
        background: #79c79f;
        box-shadow: 0px 20px 20px rgba(0, 0, 10, 0.15);
        margin: 0 auto 1rem;
        display: grid;
        place-items: center;
        border-radius: 8rem;
        width: 6rem;
        height: 6rem;
        transition: 0.25s ease-in-out;
      }

      & b {
        display: block;
        font-size: 1.5em;
      }

      &.hover {
        transform: scale(1);

        & span {
          box-shadow: 0px 5px 5px rgba(0, 0, 10, 0);
          background: transparent;
          color: #fff;
        }
      }
    }
  }

  .basicpadding {
    position: relative;
    display: flex;
    align-items: stretch;
    justify-content: center;
    gap: 2rem;
    padding: 0 1rem;
    margin: 0rem auto 4rem;
    flex-wrap: wrap;

    button {
      line-height: 1;
      display: block;
      min-height: 50px;
      min-width: 150px;
      place-items: center;
      margin: 0;
      display: block;
      align-self: stretch;
      span {
        display: grid;
        place-items: center;
        place-content: center;
      }
    }
  }
  .form {
    margin: 0;
    position: relative;
    max-width: 400px;
    min-width: 200px;
    border: 2px solid #fff;
    background: #eef1;
    border-radius: 50px;
    display: flex;
    box-shadow: 0px 5px 5px rgba(0, 0, 10, 0.2) inset;

    & label {
      flex: 1 1 calc(100% - 85px);
      width: calc(100% - 85px);
      border: 0;
      padding: 10px;
      background: none;
      border-radius: 50px 0 0 50px;
      outline: none;
      color: #fff;
    }
    & input {
      font-weight: bold;
      width: 100%;
      border: 0;
      padding: 10px;
      background: none;
      border-radius: 50px 0 0 50px;
      outline: none;
      color: #fff;
      opacity: 1;
      font-size: 1rem;
    }
    & input::placeholder {
      opacity: 0.8;
    }
    & button {
      flex: 0 1 85px;
      white-space: nowrap;
      background: none;
      border: 0;
      border-left: 2px solid #fff;
      font-weight: bold;
      border-radius: 0 50px 50px 0;
      padding: 0 0.5rem;
      transition: 0.25s ease-in-out all;
      color: #fff;
      font-size: 1rem;
      &.hover {
        border-color: #fff;
        background: #fff;
        color: #0a1530;
      }
    }
  }

  .button {
    border: 0;
    width: 280px;
    position: relative;
    pointer-events: all;
    margin: 0 auto;
    font-size: calc(16px + 0.25vw);
    font-weight: 900;
    color: rgba(255, 255, 255, 1);
    background: linear-gradient(135deg, #2c82ad, #67b26f);
    background-image: linear-gradient(135deg, oklab(0.61 -0.08 -0.21), oklab(0.66 -0.24 0.16));
    border-radius: 40px;
    text-align: center;
    display: block;
    text-decoration: none;
    line-height: 26px;
    transition: all 0.25s ease-in-out;
    padding: 0;
    margin-top: 1.5rem;
    border-top: 2px solid #0a153088;
    border-bottom: 1px solid #0a1530dd;
    @media (forced-colors: active) {
      border: 1px solid;
    }

    & span {
      position: relative;
      z-index: 1;
      padding: 0.33rem 1rem;
      content: ' ';
      display: block;

      width: calc(100%);
      height: calc(100%);
      z-index: 0;
      opacity: 1;
      transition: background 0.25s ease-in-out;
      border-radius: 40px;
      background: #0a1530;
      overflow: hidden;
    }

    & svg {
      vertical-align: middle;
      margin-left: 10px;
    }

    @media (min-width: 600px) {
      & span {
        font-size: 1.125rem;
      }
    }

    &.hover,
    &:hocus {
      text-decoration: none;

      border-top-color: #aff9;
      & span {
        background: transparent;
      }
    }
  }

  .features {
    padding: 0 1rem;
    max-width: 800px;
    margin: 4rem auto;

    & .feature {
      position: relative;
      display: flex;
      align-items: stretch;
      justify-content: center;
      flex-wrap: wrap;
      margin: 0 0 2rem;
      transition: 0.25s ease-in-out all;

      &:nth-child(even) {
        flex-direction: row-reverse;
      }

      &.hover {
        & .image {
          background: #fff;
          box-shadow: 0px 5px 5px rgba(0, 0, 10, 0);

          color: #0079b1;
        }
      }

      & .image {
        color: #0079b1;
        background: transparent;
        flex: 1;
        min-width: 200px;
        height: 200px;
        border: 2px solid #fff;
        border-radius: 2rem;
        transition: 0.25s ease-in-out all;
        box-shadow: 0px 5px 5px rgba(0, 0, 10, 0.2);

        display: grid;
        place-items: center;
      }

      & .text {
        padding: 1rem 2rem;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .footer {
    margin-top: 3rem;
    height: 50px;
    border-top: 2px solid #fff;
    text-align: center;
    line-height: 50px;
    -webkit-backdrop-filter: blur(10px);
    backdrop-filter: blur(10px);
  }

  @media (prefers-reduced-motion: no-preference) {
    .caret {
      width: 1px;
      height: 16px;
      background: currentColor;
      display: inline-block;
      vertical-align: baseline;
      margin-left: 0px;
      translate: 0 2px;
      animation: caret 0.9s ease-in-out infinite;
      opacity: 0.5;
    }

    @keyframes caret {
      50% {
        opacity: 0;
      }
    }
  }
`;

const Page = (props) => (
  <section className={styles.page}>
    <div className={styles.intro}>
      <svg viewBox="0 0 402 97" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="1.30562"
          y="29.3615"
          width="57"
          height="66"
          rx="5"
          transform="rotate(-5.22773 1.30562 29.3615)"
          stroke="#415377"
          strokeWidth="2"
        />
        <path
          className={styles.tablet}
          d="M44.4633 52.2066C44.0055 45.848 38.3921 40.9886 32.0335 41.4464C25.6283 41.9075 20.8156 47.5176 21.2734 53.8762C21.7345 60.2815 27.2979 65.0975 33.7032 64.6364C40.0617 64.1786 44.9245 58.6119 44.4633 52.2066ZM31.9568 59.3105C31.6965 59.6112 31.1822 59.6483 30.8815 59.3879L25.669 54.8756C25.3683 54.6153 25.3312 54.101 25.5916 53.8003L26.5928 52.6942C26.8498 52.3468 27.3173 52.3131 27.6214 52.6202L31.1766 55.654L37.6848 48.136C37.9417 47.7885 38.4093 47.7548 38.7134 48.0619L39.8628 49.0131C40.1635 49.2734 40.2005 49.7877 39.9402 50.0884L31.9568 59.3105Z"
          fill="#58B993"
        />
        <circle
          cx="35.2352"
          cy="81.9207"
          r="3.56794"
          transform="rotate(-5.22773 35.2352 81.9207)"
          stroke="#415377"
          strokeWidth="2"
        />
        <path
          opacity="0.2"
          d="M78.2045 50.5475C78.2045 50.5475 91.8311 46.7054 102.975 45.8487C114.118 44.992 127.745 47.1499 127.745 47.1499"
          stroke="#415377"
          strokeWidth="2"
        />
        <rect x="142.401" y="1" width="129.656" height="94" rx="5" stroke="#415377" strokeWidth="2" />
        <path
          className={styles.desktop}
          d="M227.243 54.0414C227.243 43.4164 218.493 34.6664 207.868 34.6664C197.165 34.6664 188.493 43.4164 188.493 54.0414C188.493 64.7445 197.165 73.4164 207.868 73.4164C218.493 73.4164 227.243 64.7445 227.243 54.0414ZM205.603 64.3539C205.134 64.8226 204.274 64.8226 203.806 64.3539L195.681 56.2289C195.212 55.7601 195.212 54.9008 195.681 54.432L197.478 52.7133C197.946 52.1664 198.728 52.1664 199.196 52.7133L204.743 58.182L216.462 46.4633C216.931 45.9164 217.712 45.9164 218.181 46.4633L219.978 48.182C220.446 48.6508 220.446 49.5101 219.978 49.9789L205.603 64.3539Z"
          fill="#58B993"
        />
        <line x1="142.745" y1="13.9375" x2="272.057" y2="13.9375" stroke="#415377" strokeWidth="2" />
        <path
          opacity="0.2"
          d="M287.362 44.7053C287.362 44.7053 301.509 44.1583 312.544 45.9329C323.579 47.7074 336.322 52.9939 336.322 52.9939"
          stroke="#415377"
          strokeWidth="2"
        />
        <rect
          x="364.64"
          y="22.8397"
          width="37"
          height="66"
          rx="5"
          transform="rotate(12.255 364.64 22.8397)"
          stroke="#415377"
          strokeWidth="2"
        />
        <path
          className={styles.mobile}
          d="M382.274 62.7157C383.145 58.556 380.437 54.4126 376.278 53.5411C372.087 52.6631 367.975 55.3773 367.103 59.537C366.225 63.7273 368.909 67.8336 373.099 68.7116C377.259 69.5832 381.396 66.9059 382.274 62.7157ZM372.955 64.9778C372.733 65.1229 372.397 65.0524 372.252 64.8304L369.738 60.983C369.592 60.761 369.663 60.4246 369.885 60.2795L370.729 59.754C370.958 59.5784 371.264 59.6425 371.402 59.895L373.125 62.491L378.674 58.8645C378.903 58.6888 379.209 58.7529 379.347 59.0055L379.91 59.8257C380.055 60.0477 379.984 60.3842 379.762 60.5292L372.955 64.9778Z"
          fill="#58B993"
        />
        <rect
          x="369.23"
          y="29.9765"
          width="7"
          height="7"
          rx="3.5"
          transform="rotate(12.255 369.23 29.9765)"
          stroke="#415377"
          strokeWidth="2"
        />
      </svg>
      <b>Polypane syncs everything</b>
    </div>

    <div className={styles.dots}>
      <div
        className={props.hoveredItem === 1 ? styles.hover : ''}
        onMouseOver={() => props.setHoveredItem(1)}
        onMouseOut={() => props.setHoveredItem(0)}
      >
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-arrows-sort"
            width="64"
            height="64"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M3 9l4 -4l4 4m-4 -4v14" />
            <path d="M21 15l-4 4l-4 -4m4 4v-14" />
          </svg>
        </span>
        <b>Scroll</b>
      </div>

      <div
        className={props.hoveredItem === 2 ? styles.hover : ''}
        onMouseOver={() => props.setHoveredItem(2)}
        onMouseOut={() => props.setHoveredItem(0)}
      >
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-mouse"
            width="64"
            height="64"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5" />
            <path d="M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5" />
            <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5" />
            <path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47" />
          </svg>
        </span>
        <b>Hover</b>
      </div>
      <div
        className={props.hoveredItem === 8 ? styles.hover : ''}
        onMouseOver={() => props.setHoveredItem(8)}
        onMouseOut={() => props.setHoveredItem(0)}
      >
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="icon icon-tabler icons-tabler-outline icon-tabler-click"
          >
            <path d="M3 12l3 0" />
            <path d="M12 3l0 3" />
            <path d="M7.8 7.8l-2.2 -2.2" />
            <path d="M16.2 7.8l2.2 -2.2" />
            <path d="M7.8 16.2l-2.2 2.2" />
            <path d="M12 12l9 3l-4 2l-2 4l-3 -9" />
          </svg>
        </span>
        <b>Click</b>
      </div>

      <div
        className={props.hoveredItem === 3 ? styles.hover : ''}
        onMouseOver={() => props.setHoveredItem(3)}
        onMouseOut={() => props.setHoveredItem(0)}
      >
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-keyboard"
            width="64"
            height="64"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="2" y="6" width="20" height="12" rx="2" />
            <line x1="6" y1="10" x2="6" y2="10" />
            <line x1="10" y1="10" x2="10" y2="10" />
            <line x1="14" y1="10" x2="14" y2="10" />
            <line x1="18" y1="10" x2="18" y2="10" />
            <line x1="6" y1="14" x2="6" y2="14.01" />
            <line x1="18" y1="14" x2="18" y2="14.01" />
            <line x1="10" y1="14" x2="14" y2="14" />
          </svg>
        </span>
        <b>Type</b>
      </div>
    </div>

    <b className={styles.title}>Try it:</b>
    <div className={styles.basicpadding}>
      <button
        type="button"
        className={[styles.button, props.button2Hovered ? styles.hover : ''].join(' ')}
        onClick={props.handleButtonClick}
        onFocus={() => props.setButton2Hover(true)}
        onMouseOver={() => props.setButton2Hover(true)}
        onMouseOut={() => props.setButton2Hover(false)}
        onBlur={() => props.setButton2Hover(false)}
      >
        <span>
          {props.buttonCount} click{props.buttonCount === 1 ? '' : 's'}
        </span>
      </button>

      <div className={styles.form}>
        <label aria-label="Synced text input">
          <input
            type="text"
            placeholder="Type something here"
            value={props.inputText}
            onChange={(e) => props.setInputText(e.target.value)}
          />
        </label>
      </div>
    </div>

    <b className={styles.title}>Build, Debug and Test</b>
    <div className={styles.features}>
      <div
        className={[styles.feature, props.hoveredItem === 4 ? styles.hover : ''].join(' ')}
        onMouseOver={() => props.setHoveredItem(4)}
        onMouseOut={() => props.setHoveredItem(0)}
      >
        <div className={styles.image}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-layout-cards"
            width="80"
            height="80"
            viewBox="0 0 24 24"
            strokeWidth="1"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="4" y="4" width="6" height="16" rx="2" />
            <rect x="14" y="4" width="6" height="10" rx="2" />
          </svg>
        </div>
        <div className={styles.text}>
          <b>Create as many panes as you need</b>
          Find the overview that works for you. Store your favorite configurations in workspaces and share them with
          your team.
        </div>
      </div>
      <div
        className={[styles.feature, props.hoveredItem === 5 ? styles.hover : ''].join(' ')}
        onMouseOver={() => props.setHoveredItem(5)}
        onMouseOut={() => props.setHoveredItem(0)}
      >
        <div className={styles.image}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-arrows-maximize"
            width="80"
            height="80"
            viewBox="0 0 24 24"
            strokeWidth="1"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="16 4 20 4 20 8" />
            <line x1="14" y1="10" x2="20" y2="4" />
            <polyline points="8 20 4 20 4 16" />
            <line x1="4" y1="20" x2="10" y2="14" />
            <polyline points="16 20 20 20 20 16" />
            <line x1="14" y1="14" x2="20" y2="20" />
            <polyline points="8 4 4 4 4 8" />
            <line x1="4" y1="4" x2="10" y2="10" />
          </svg>
        </div>
        <div className={styles.text}>
          <b>Resize panes whenever you want</b>
          Use our device presets, your own CSS breakpoints or freeform resize panes right on the main canvas.
        </div>
      </div>
      <div
        className={[styles.feature, props.hoveredItem === 6 ? styles.hover : ''].join(' ')}
        onMouseOver={() => props.setHoveredItem(6)}
        onMouseOut={() => props.setHoveredItem(0)}
      >
        <div className={styles.image}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-arrows-maximize"
            width="80"
            height="80"
            viewBox="0 0 24 24"
            strokeWidth="1"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M 8,20 H 6 C 5,20 4,19 4,18 4,14 4,10 4,6 4,5 5,4 6,4 h 12 c 1,0 2,1 2,2 v 2" />
            <path fill="currentColor" strokeWidth="0" d="m 21,14 -4,2 4,4 -1,1 -4,-4 -2,4 -3,-10 z" />
          </svg>
        </div>
        <div className={styles.text}>
          <b>Synced element inspector and console</b>
          An element inspector and a fully functional console that works seamlessly across all panes, eliminating
          duplicate tasks.
        </div>
      </div>
      <div
        className={[styles.feature, props.hoveredItem === 7 ? styles.hover : ''].join(' ')}
        onMouseOver={() => props.setHoveredItem(7)}
        onMouseOut={() => props.setHoveredItem(0)}
      >
        <div className={styles.image}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="icon icon-tabler icon-tabler-tools"
            width="80"
            height="80"
            viewBox="0 0 24 24"
            strokeWidth="1"
            stroke="currentColor"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4" />
            <line x1="14.5" y1="5.5" x2="18.5" y2="9.5" />
            <polyline points="12 8 7 3 3 7 8 12" />
            <line x1="7" y1="8" x2="5.5" y2="9.5" />
            <polyline points="16 12 21 17 17 21 12 16" />
            <line x1="16" y1="17" x2="14.5" y2="18.5" />
          </svg>
        </div>
        <div className={styles.text}>
          <b>Dozens and dozens of debug tools</b>
          Layout debugging, color blindness testers, built-in live reloading, screenshotting, device and media
          emulation...The list goes on.
        </div>
      </div>
    </div>

    <b className={styles.title}>Everything you need to create amazing sites and webapps</b>
    <a
      href="https://dashboard.polypane.app/register"
      className={[styles.button, props.button3Hovered ? styles.hover : ''].join(' ')}
      onFocus={() => props.setButton3Hover(true)}
      onMouseOver={() => props.setButton3Hover(true)}
      onMouseOut={() => props.setButton3Hover(false)}
      onBlur={() => props.setButton3Hover(false)}
    >
      <span>Start your free trial</span>
    </a>
  </section>
);

const Demo = () => {
  const [inputText, setInputText] = useState('');
  const [buttonHovered, setButtonHover] = useState(false);
  const [button2Hovered, setButton2Hover] = useState(false);
  const [button3Hovered, setButton3Hover] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const [buttonCount, setButtonCount] = useState(0);

  useEffect(() => {
    ReactTooltip.rebuild();
  }, []);

  const handleButtonClick = () => {
    setButtonCount(buttonCount + 1);
  };

  return (
    <div className={styles.liveDemo} id="demo">
      <h2>This is how using it feels </h2>
      <p>Click, hover, scroll, focus and type. Your actions happen across all panes.</p>

      <a href="#faq" className={styles.skipButton}>
        Skip to after the demo
      </a>

      <div className={styles.uiWrapper}>
        <div className={styles.urlBarWrap}>
          <div className={styles.urlBar} data-tip="Download Polypane to test your own sites!">
            https://localhost:1337
            <div className={styles.caret} />
          </div>
        </div>
        <ScrollSync horizontal={false}>
          <div className={styles.mainWrapper}>
            <div className={styles.largePaneWrap}>
              <ScrollSyncPane>
                <div className={styles.largePane}>
                  <Page
                    inputText={inputText}
                    setInputText={setInputText}
                    buttonHovered={buttonHovered}
                    setButtonHover={setButtonHover}
                    button2Hovered={button2Hovered}
                    setButton2Hover={setButton2Hover}
                    button3Hovered={button3Hovered}
                    setButton3Hover={setButton3Hover}
                    hoveredItem={hoveredItem}
                    setHoveredItem={setHoveredItem}
                    menuOpen={menuOpen}
                    setMenuOpen={setMenuOpen}
                    handleButtonClick={handleButtonClick}
                    buttonCount={buttonCount}
                  />
                </div>
              </ScrollSyncPane>
            </div>

            <div className={styles.mediumPaneWrap}>
              <ScrollSyncPane>
                <div className={styles.mediumPane}>
                  <Page
                    inputText={inputText}
                    setInputText={setInputText}
                    buttonHovered={buttonHovered}
                    setButtonHover={setButtonHover}
                    button2Hovered={button2Hovered}
                    setButton2Hover={setButton2Hover}
                    button3Hovered={button3Hovered}
                    setButton3Hover={setButton3Hover}
                    hoveredItem={hoveredItem}
                    setHoveredItem={setHoveredItem}
                    handleButtonClick={handleButtonClick}
                    buttonCount={buttonCount}
                  />
                </div>
              </ScrollSyncPane>
            </div>

            <div className={styles.smallPaneWrap}>
              <ScrollSyncPane>
                <div className={styles.smallPane}>
                  <Page
                    inputText={inputText}
                    setInputText={setInputText}
                    buttonHovered={buttonHovered}
                    setButtonHover={setButtonHover}
                    button2Hovered={button2Hovered}
                    setButton2Hover={setButton2Hover}
                    button3Hovered={button3Hovered}
                    setButton3Hover={setButton3Hover}
                    hoveredItem={hoveredItem}
                    setHoveredItem={setHoveredItem}
                    handleButtonClick={handleButtonClick}
                    buttonCount={buttonCount}
                  />
                </div>
              </ScrollSyncPane>
            </div>
          </div>
        </ScrollSync>
      </div>
    </div>
  );
};

export default Demo;
